import React from 'react'
import { P } from '@farewill/ui'
import { GTR } from '@farewill/ui/tokens'
import { PRODUCTS } from 'lib/products/constants'
import { RoleSection, RoleTemplate, RoleTitle, RoleUl } from '../RoleTemplate'

const ProbateSalesTeamLead = (): React.JSX.Element => (
  <RoleTemplate
    roleName="Legal Assistant (Probate)"
    roleUrl="https://dignity.kallidusrecruit.com/vacancyinformation.aspx?vguid=ae834c4a-1d69-4dc3-af67-f103654db68d"
    location="Maidenhead (Hybrid – 3 days on-site, 2 days from home)"
    salary="£27,000 per annum"
    contractType="Full-time, Permanent"
    closingDate="1st August 2025"
    product={PRODUCTS.PROBATE}
    content={
      <>
        <RoleSection margin={[GTR.M, 0]}>
          <RoleTitle>The Role</RoleTitle>
          <P>
            We help families through some of the hardest days of their lives. As
            part of the UK&apos;s leading end-of-life group, Dignity supports 1
            in every 8 families after a death, and increasingly, many of them
            need expert guidance on probate and estate administration.
          </P>
          <P>
            We&apos;re growing fast, and we&apos;re looking for an ambitious Law
            Graduate or college leaver to join us on that journey. You&apos;ll
            gain hands-on legal experience in a complex, regulated area of law
            while supporting people with empathy and clarity during a difficult
            time.
          </P>
          <P>
            This is a chance to kick-start your legal career in a purpose-led
            business - one that values emotional intelligence as much as
            academic achievement.
          </P>
        </RoleSection>
        <RoleSection margin={[GTR.M, 0]}>
          <RoleTitle>What you will be doing</RoleTitle>
          <RoleUl>
            <li>
              Supporting probate and estate administration across a wide range
              of estates - from simple cases to complex, high-value ones.
            </li>
            <li>
              Drafting and reviewing legal documents, correspondence, and
              application forms.
            </li>
            <li>
              Managing information using our case management software and
              databases.
            </li>
            <li>
              Helping to meet compliance and regulatory obligations, including
              fraud and anti-money laundering checks.
            </li>
            <li>
              Participating in audits and internal training to build your
              understanding and improve service quality.
            </li>
          </RoleUl>
        </RoleSection>
        <RoleSection margin={[GTR.M, 0]}>
          <RoleTitle>What We&apos;re Looking For</RoleTitle>
          <RoleUl>
            <li>
              Empathetic and articulate - able to explain sensitive legal
              processes with clarity and care.
            </li>
            <li>
              Proactive - ready to get stuck in and learn fast in a busy team.
            </li>
            <li>
              Reliable and detail-oriented - someone who takes pride in getting
              things right.
            </li>
            <li>
              Interested in private client, probate or estate work as a
              long-term career path.
            </li>
          </RoleUl>
        </RoleSection>
        <RoleSection margin={[GTR.M, 0]}>
          <RoleTitle>Training and development</RoleTitle>
          <P>
            We invest in your career from day one. As a Legal Assistant,
            you&apos;ll receive:
          </P>
          <RoleUl>
            <li>
              Structured on-the-job training, with regular supervision from
              senior team members.
            </li>
            <li>
              Mentorship to help you build skills in probate, estate
              administration, and legal service delivery.
            </li>
            <li>
              Support to explore future legal qualification routes (including
              sponsorship for further study, after an initial period in the
              role).
            </li>
          </RoleUl>
          <P>
            This is a fantastic way to discover if private client, probate or
            legal work is right for you—no law degree required.
          </P>
        </RoleSection>
        <RoleSection margin={[GTR.M, 0]}>
          <RoleTitle>You&apos;ll also need</RoleTitle>
          <RoleUl>
            <li>English & Maths GCSE (or equivalent) at grade C/4 or above.</li>
            <li>
              At least 96 UCAS points (CCC at A-level or equivalent vocational
              qualification).
            </li>
            <li>Strong written and verbal communication skills.</li>
            <li>
              Confidence in using Microsoft Office and learning new software.
            </li>
          </RoleUl>
        </RoleSection>
        <RoleSection margin={[GTR.M, 0]}>
          <RoleTitle>What we offer</RoleTitle>
          <RoleUl>
            <li>Annual salary of £27,000</li>
            <li>25 Days Holiday + Bank Holidays</li>
            <li>X2 Life Assurance</li>
            <li>Pension Scheme</li>
            <li>Hybrid flexible working (3 days in our Maidenhead office)</li>
            <li>Genuine career progression and mentorship opportunities</li>
            <li>
              A chance to make a meaningful contribution to people&apos;s lives
              and deaths
            </li>
          </RoleUl>
        </RoleSection>
      </>
    }
  />
)

export default ProbateSalesTeamLead
